'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/stage4/components/statements.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _helpInfo = require('@marmalade/help-info');
var _reduxWindow = require('redux-window');
var _reactRedux = require('react-redux');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Statements(_ref) {
  var width = _ref.width;
  return _react2.default.createElement(_react.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: this
  }, _react2.default.createElement('h2', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: this
  }, 'Nearly done...'), _react2.default.createElement('p', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    },
    __self: this
  }, 'Please confirm that all of the following statements apply to you:'), _react2.default.createElement('ol', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: this
  }, _react2.default.createElement('li', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: this
  }, 'I confirm that all of the above information is correct and I wish to proceed with the purchase of my Learner Driver Insurance policy.'), _react2.default.createElement('li', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: this
  }, 'I confirm I understand this policy and its cover ceases when I pass my full UK driving test.'), _react2.default.createElement('li', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }, 'I confirm I understand this policy only operates in the Territories of England, Wales, Scotland and Northern Ireland.'), _react2.default.createElement('li', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  }, 'I confirm that I have never had any motor proposal declined, policy cancelled or voided, special terms imposed by a motor insurer, renewal refused nor been required to pay an increased premium.'), _react2.default.createElement('li', {
    style: {
      position: 'relative'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  }, 'I understand that I am not covered if I have not told the DVLA about any notifiable medical condition which could affect the validity of my license. ', _react2.default.createElement(_helpInfo.HelpButton, {
    id: 'dvla-statement',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  }), _react2.default.createElement('div', {
    style: width < 768 ? undefined : {
      position: 'absolute',
      width: '100%',
      top: 0
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }, _react2.default.createElement(_helpInfo.HelpText, {
    id: 'dvla-statement',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  }, 'This is a condition that could affect your driving.'))), _react2.default.createElement('li', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32
    },
    __self: this
  }, 'I confirm that the insured car is not a left-hand drive or a Q plate vehicle.')), _react2.default.createElement('hr', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34
    },
    __self: this
  }));
}
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    width: (0, _reduxWindow.getWidth)(state)
  };
})(Statements);